export { default } from '../utils/photoswipe';
